export const STATUS = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BLOCKED: 'BLOCKED',
  MIGRATED: 'MIGRATED'
})

export const STATUS_DETAILS = Object.freeze({
  [STATUS.ACTIVE]: { status: STATUS.ACTIVE, label: 'Ativo' },
  [STATUS.INACTIVE]: { status: STATUS.INACTIVE, label: 'Inativo' },
  [STATUS.BLOCKED]: { status: STATUS.BLOCKED, label: 'Bloqueado' },
  [STATUS.MIGRATED]: { status: STATUS.MIGRATED, label: 'Migrado' }
})

export const STATUS_REASON = Object.freeze({
  DECEASED: 'DECEASED',
  COMPANY_EMPLOYEE: 'COMPANY_EMPLOYEE',
  PARTIAL_FRAUD: 'PARTIAL_FRAUD',
  FRAUD: 'FRAUD',
  MEMBER_REQUEST: 'MEMBER_REQUEST',
  NEW_CLUB_MIGRATION: 'NEW_CLUB_MIGRATION',
  COMPANY_RESELLER: 'COMPANY_RESELLER',
  REGION_CHANGE: 'REGION_CHANGE',
  UNINFORMED: 'UNINFORMED',
  PRE_MIGRATION: 'PRE_MIGRATION',
  INVALID_DATA: 'INVALID_DATA',
  FRAUD_THIRD_LINKED: 'FRAUD_THIRD_LINKED',
  UNBLOCK_BLOCKLIST: 'UNBLOCK_BLOCKLIST',
  NEW_TELEPHONE_MIGRATION: 'NEW_TELEPHONE_MIGRATION'
})
